import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Row,
} from "../../../components/Component";
import MyDataTable from "../../../myComponents/DataTable/MyDataTable";
import { getStudentQueryListAPI, replyStudentQueryApi } from "../../../api/LMS/master";
import { toast } from "react-toastify";
import { Badge, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const StudentQuery = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [replyText, setReplyText] = useState("");

  const handleReply = (query) => {
    setSelectedQuery(query);
    setReplyText("");
    setShowModal(true);
  };

  const submitReply = () => {
    if (!replyText.trim()) {
      toast.warning("Reply cannot be empty");
      return;
    }

    const body = {
      queryId: selectedQuery.id,
      reply: replyText,
    };

    replyStudentQueryApi(body)
      .then((res) => {
        if (res.data.status === true) {
          toast.success("Reply sent successfully!");
          setShowModal(false);
          getStudentQuery();
        } else {
          toast.warning(res.data.message);
        }
      })
      .catch(() => toast.error("Something went wrong"));
  };

  const columns = [
    {
      name: "Enrollment no",
      selector: (row) => row?.enrollment_no,
      sortable: true,
      wrap: true,
      width: "150px",
    },
    {
      name: "Student Name",
      selector: (row) => row?.student_name,
      sortable: true,
      wrap: true,
      width: "150px",
    },
    {
      name: "Class",
      selector: (row) => row?.class_name,
      sortable: true,
      wrap: true,
      width: "80px",
    },
    {
      name: "Stream",
      selector: (row) => row?.stream_name,
      sortable: true,
      wrap: true,
      width: "200px",
    },
    {
      name: "Subject",
      selector: (row) => row?.subject_name,
      sortable: true,
      wrap: true,
      width: "200px",
    },
    {
      name: "Query",
      selector: (row) => row?.query,
      sortable: true,
      wrap: true,
    },
    {
      name: "Reply",
      selector: (row) => (
        <div className="my-3">
          <span className="">{row.reply}</span>
        </div>
      ),
      wrap: true,
      width: "250px",
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <Badge
          color={row.status === "pending" ? "warning" : "success"}
          variant="outlined"
          size="small"
          className="text-capitalize"
        >
          {row.status}
        </Badge>
      ),
      sortable: true,
      wrap: true,
      width: "110px",
    },
    {
      name: "Action",
      cell: (row) =>
        row.status?.toLowerCase() === "pending" ? (
          <Button size="sm" color="primary" onClick={() => handleReply(row)}>
            Reply
          </Button>
        ) : (
          <Badge className="font-weight-bold text-wrap">Already Replied</Badge>
        ),
      ignoreRowClick: true,
      allowOverflow: true,
    },
  ];

  const getStudentQuery = () => {
    setIsLoading(true);
    getStudentQueryListAPI({})
      .then((res) => {
        if (res.data.status === true) {
          setData(res.data.data);
        } else {
          setData([]);
          toast.clearWaitingQueue();
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getStudentQuery();
  }, []);

  return (
    <>
      <Head title="Student Query List" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Student Query
              </BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row className="g-gs">
            <MyDataTable data={data} columns={columns} isLoading={isLoading} title="Student Query List" />
          </Row>

          <Modal isOpen={showModal} toggle={() => setShowModal(!showModal)}>
            <ModalHeader toggle={() => setShowModal(false)}>Reply to Student Query</ModalHeader>
            <ModalBody>
              <p>
                <strong>Query:</strong> {selectedQuery?.query}
              </p>
              <textarea
                className="form-control"
                rows={5}
                value={replyText}
                onChange={(e) => setReplyText(e.target.value)}
                placeholder="Write your reply..."
              />
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={() => setShowModal(false)}>
                Close
              </Button>
              <Button color="primary" onClick={submitReply}>
                Send Reply
              </Button>
            </ModalFooter>
          </Modal>
        </Block>
      </Content>
    </>
  );
};

export default StudentQuery;
